import React, { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { MainContext } from "../App";
import chibiZayDesktop from "../@shared/assets/loadingScreens/chibi-zay-io-s3.png";
import chibiZayMobile from "../@shared/assets/loadingScreens/chibi-zay-io-s3-mobile.png";
import electadDesktop from "../@shared/assets/loadingScreens/electad-s3-bg.png";
import electadMobile from "../@shared/assets/loadingScreens/electad-s3-bg-mobile.png";
import newDesktop from "../@shared/assets/loadingScreens/new-s3-bg.png";
import newMobile from "../@shared/assets/loadingScreens/new-s3-bg-mobile.png";
import runesDesktop from "../@shared/assets/loadingScreens/runes-s3-bg.png";
import runesMobile from "../@shared/assets/loadingScreens/runes-s3-bg-mobile.png";
import voidrickDesktop from "../@shared/assets/loadingScreens/voidrick-s3-bg.png";
import voidrickMobile from "../@shared/assets/loadingScreens/voidrick-s3-bg-mobile.png";

const LOADING_SCREEN_OPTIONS = [
  { desktop: chibiZayDesktop, mobile: chibiZayMobile },
  { desktop: electadDesktop, mobile: electadMobile },
  { desktop: newDesktop, mobile: newMobile },
  { desktop: runesDesktop, mobile: runesMobile },
  { desktop: voidrickDesktop, mobile: voidrickMobile },
];

const LoadingScreen = () => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const { gameScreenLoading, setGameScreenLoading, Theme } =
    useContext(MainContext);

  const [progress, setProgress] = useState(0);
  const [selectedScreen, setSelectedScreen] = useState(
    LOADING_SCREEN_OPTIONS[0]
  );

  useEffect(() => {
    if (!gameScreenLoading) return undefined;

    setProgress(0);
    setSelectedScreen(
      LOADING_SCREEN_OPTIONS[
        Math.floor(Math.random() * LOADING_SCREEN_OPTIONS.length)
      ]
    );

    let startTime = Date.now();
    let hideTimeout;

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min(
        100,
        Math.floor((elapsed / 3000) * 100 + Math.random() * 5)
      );
      setProgress(newProgress);

      if (elapsed >= 3000) {
        clearInterval(interval);
        setProgress(100);
        hideTimeout = setTimeout(() => setGameScreenLoading(false), 3000);
      }
    }, 150);

    return () => {
      clearInterval(interval);
      clearTimeout(hideTimeout);
    };
  }, [gameScreenLoading, setGameScreenLoading]);

  const backgroundUrl = isMobile
    ? selectedScreen.mobile
    : selectedScreen.desktop;

  if (!gameScreenLoading) return null;

  return (
    <Box
      sx={{
        width: "100dvw",
        height: "100dvh",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000",
        position: "absolute",
        zIndex: 9999,
        top: 0,
        left: 0,
      }}
    >
      <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
        <img
          src={backgroundUrl}
          alt="Loading Background"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />

        {/* 🔵 Loading bar (bottom) */}
        <Typography
          variant="h4"
          sx={{
            position: "absolute",
            bottom: 45,
            left: "10%",
            fontWeight: 900,
            color: Theme.palette.text.main,
            textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.main}, 1px -1px 0 ${Theme.palette.tirciary.main}, -1px  1px 0 ${Theme.palette.tirciary.main}, 1px  3px 0 ${Theme.palette.tirciary.main}`,
          }}
        >
          LOADING...
        </Typography>
        <Box
          sx={{
            position: "absolute",
            bottom: 30,
            left: "10%",
            width: "80%",
            height: 12,
            backgroundColor: "#333",
            borderRadius: 6,
            overflow: "hidden",
            boxShadow: "0 0 8px rgba(0,0,0,0.7)",
            border: `3px solid ${Theme.palette.primary.main}`,
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: `${progress}%`,
              background: `linear-gradient(90deg,  ${Theme.palette.tirciary.main}, ${Theme.palette.secondary.main})`,
              transition: "width 0.2s ease-in-out",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LoadingScreen;
